import { FormFeedback } from '@wearetla/tla-essentials-tools/partials/forms';
import '/assets/styles/partials/forms/form-feedback.scss';

export default FormFeedback;
